import styled from "styled-components";

export const Titulo = styled.h1`
    color: #000;
    font-size: 40px;
`;

